<template>
  <v-dialog v-model="isOpenLocal" persistent width="500">
    <v-card>
      <v-card-title>Sending to All</v-card-title>
      <v-card-text>
        <span>
          <span class="mr-2">Sending to all recipients. Please wait</span>
          <v-progress-circular
            :width="3"
            :size="20"
            indeterminate
            color="primary"
          ></v-progress-circular
        ></span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "csr-notification-page-send-to-all-loading-dialog",

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isOpenLocal: this.isOpen,
    };
  },

  watch: {
    isOpen(val) {
      this.isOpenLocal = val;
    },

    isOpenLocal(val) {
      this.$emit("update:isOpen", val);
    },
  },
};
</script>
